module.exports = {
    URL: 'https://api.ecombd.org',
};
// module.exports = {
//     URL: 'http://localhost:4000',
// };
